export default class {
	static formatName(pointName) {
		return pointName;
		// We might still need this for Hoyts.
		// if (pointName) {
		// 	let splitName = pointName.split(".");
		// 	if (!splitName || !splitName.length) {
		// 		return pointName;
		// 	}

		// 	let newName = "";
		// 	if (splitName.length === 1) {
		// 		newName = splitName[0];
		// 	} else if (splitName.length === 2) {
		// 		newName = splitName[0] + " " + splitName[1];
		// 	} else if (splitName.length === 3) {
		// 		newName = splitName[1] + " " + splitName[2];
		// 	} else {
		// 		for (var ii = 1; ii < splitName.length - 1; ii++) {
		// 			if (ii !== 1) {
		// 				newName += " ";
		// 			}
		// 			newName += splitName[ii];
		// 		}
		// 	}
		// 	return newName;
		// }
	}

	static formatDescription(point, showUnitDescription = false) {
		if (point) {
			if (showUnitDescription) {
				//remove silly brace description
				let unitDesc = ((point.unitsDescription && point.unitsDescription.replace(/{(.*)}/, "$1") + " ") || "");
				return (
					this.formatName(point.pointName || point.name) + (unitDesc !== "" ? "(" + unitDesc + ")" : "")
				);
			} else {
				//remove silly brace description
				return point.description || this.formatName(point.pointName || point.name);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/pointName.js